    import React from "react";
    import { useSelector } from "react-redux";
    import { RootState } from "../../../store";

    import MultilingualDashboard1 from "./MultilingualDashboard1";
    import MultilingualDashboard2 from "./MultilingualDashboard2";
    import MultilingualDashboard3 from "./MultilingualDashboard3";

    interface ParentProps {
    finYear: string;
    meetingType: any;
    }

    const MultilingualDashboard: React.FC<ParentProps> = ({ finYear, meetingType }) => {
    const multilingualData = useSelector(
        (state: RootState) => state.common.dashboardData["Multilingual Coverage"]
    );

    const { meeting_language, meeting_language_desc, taskId } = multilingualData || {};
    let DashboardComponent;

    if (taskId && taskId !== "") {
        DashboardComponent = MultilingualDashboard3;
    } else if (meeting_language && meeting_language_desc) {
        DashboardComponent = MultilingualDashboard2;
    } else {
        DashboardComponent = MultilingualDashboard1;
    }

    return <DashboardComponent finYear={finYear} meetingType={meetingType} />;
    };

    export default MultilingualDashboard;